import React, { useEffect, useRef, useState } from "react";
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON } from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import Modal from "../../components/common/Model";
import Inputwithlable from "../../components/common/inputwithlable";
import {
  addAdminDimension,
  deleteDimensionById,
  getAdminDimensionBlock,
  getallAdminDimension,
  getAllModels,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { handleFormInput } from "../../../utills/formutilities";
import moment from "moment";
import Textareawithlable from "../../components/common/textareawithlable";
import SuccessModel from "../../components/common/SuccessModel";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import DeleteModal from "../../components/common/DeleteModal";
import { API_RESPONSE } from "../../../utills/app-constant";

const DimensionsManagement = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [totalElement, settotalElement] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  let status = 0
  const [dimensionPayload, setDimensionPayload] = useState({
    id: "",
    dimensionName: "",
    sortName: "",
    dimensionDescription: "",
    modelId: "",
  });
  const [isEditMode, setIsEditMode] = useState(false); // Track if in edit mode
  const [editModelId, setEditModelId] = useState(null); // Store model ID being edited
  const [isViewMode, setIsViewMode] = useState(false);
  const [viewModelId, setViewModelId] = useState(false)
  const [modelId, setModelId] = useState(localStorage.getItem("DimesionMenegmentModalId") || "");
  const [modelList, setModelList] = useState([]);
  const [modelListActive, setModelListActive] = useState([]);
  const [searchValue, setSearchValue] = useState(""); // Search state
  const successModalRef = useRef();
  const addbuttonClick = useRef();
  const DeleteDimensionRef = useRef()
  const { value } = useSelector((state) => state?.adminRole);
  const [permissionAccess, setPermissionAccess] = useState();
  let dimesionModalId = localStorage.getItem("DimesionMenegmentModalId");
  const [deleteDimensionId, setDeleteDimensionIdId] = useState(null);
     const [deleteDimensionName, setDeleteDimensionName] = useState();
  useEffect(() => {
    const FlashAssessmentFilterData =
      value && value?.filter((v) => v.moduleName === "Campaign Management");
    setPermissionAccess(FlashAssessmentFilterData?.[0]);
  }, [value]);
console.log("rowData------------------",rowData);
  // Function to open modal for adding new model
  const addButtonClick = () => {
    setIsEditMode(false); // Reset to add mode
    setDimensionPayload({
      id: "",
      dimensionName: "",
      sortName: "",
      dimensionDescription: "",
      modelId: "",
    }); // Clear previous payload
    addbuttonClick.current.click();
  };

  // Function to open modal for editing a model
  const editButtonClick = (model) => {
    setIsEditMode(true); // Set to edit mode
    setDimensionPayload({
      id: model.id,
      dimensionName: model.dimensionName,
      sortName: model.sortName,
      dimensionDescription: model.dimensionDescription,
      modelId: model.modelResponse.id,
      enable: model.modelResponse.enable,
    });
    setEditModelId(model.id);
    addbuttonClick.current.click();
  };

  const viewButtonClick = (model) => {
    setIsViewMode(true); // Set to edit mode
    setDimensionPayload({
      id: model.id,
      dimensionName: model.dimensionName,
      sortName: model.sortName,
      dimensionDescription: model.dimensionDescription,
      modelId: model.modelResponse.id,
      enable: model.modelResponse.enable,
    });

    setViewModelId(model.id);
    addbuttonClick.current.click();
  };

  const getListOfDimension = async () => {
    try {
      setPending(true);
      const response = await getallAdminDimension(
        page,
        pageSize,
        searchValue,
        sortDirection,
        sortColumn, status, dimesionModalId ? dimesionModalId : modelId
      );
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.dimensionResponsePayloadList);
        settotalElement(response?.data?.responseBody?.totalElement);
        setPending(false);
      } else {
        setRowData([]);
        setPending(false);
      }
    } catch (err) {
      setPending(false);
    }
  };

  const getListOfModel = async () => {
    try {
      const response = await getAllModels(0);
      if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.modelName,
          Status: model.status,
        }));
        const modelOptionsActive = response?.data?.responseBody
          ?.filter((model) => model?.status === 1) // Only keep models with status === 1
          ?.map((model) => ({
            value: model.id,
            label: model.modelName,
            Status: model.status,
          }));
        setModelList(modelOptions);
        setModelListActive(modelOptionsActive)
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    getListOfModel();
  }, []);

  const handleChange = (event) => {
    setDimensionPayload(handleFormInput(event, dimensionPayload));
  };

  const handleSelect = (event) => {
    if (dimensionPayload?.enable === false) {
      toastEmitter("warning", "This dimension is disabled, and you cannot change the model.");
      return;
    }
    setDimensionPayload(handleFormInput(event, dimensionPayload));
  };

  const handlemodalSelect = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "") {
      localStorage.removeItem("DimesionMenegmentModalId");
      setModelId("");
    } else {
      localStorage.setItem("DimesionMenegmentModalId", selectedValue);
      setModelId(selectedValue);
    }
  };

  useEffect(() => {
    getListOfDimension();
  }, [page, pageSize, searchValue, sortColumn, sortDirection, modelId, dimesionModalId]);


  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  function checkProperties(obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] !== "") return false;
    }
    return true;
  }

  const onAddOrEditModel = async () => {
    const isEmpty = checkProperties(dimensionPayload);
    if (isEmpty) {
      return toastEmitter(
        "error",
        "Fields marked with an asterisk (*) are required!"
      );
    }

    if (
      !dimensionPayload.dimensionName ||
      dimensionPayload.dimensionName?.trim() === ""
    ) {
      return toastEmitter("error", "Dimension Name is required!");
    }

    if (
      !dimensionPayload.modelId ||
      dimensionPayload.modelId === ""
    ) {
      return toastEmitter("error", "Model is required!");
    }

    if (
      !dimensionPayload.sortName ||
      dimensionPayload.sortName?.trim() === ""
    ) {
      return toastEmitter("error", "Sort Name is required!");
    }

    if (
      !dimensionPayload.dimensionDescription ||
      dimensionPayload.dimensionDescription?.trim() === ""
    ) {
      return toastEmitter("error", "Dimension Description is required!");
    }

    try {
      let response = await addAdminDimension(dimensionPayload); // Update model
      if (response?.data?.responseCode === 200) {
        successModalRef.current.click();
        getListOfDimension(); // Refresh model list after successful add/edit
      } else if (response?.data?.responseCode === 400) {
        toastEmitter("error", response?.data?.message);
      } else {
        console.error("Failed to add or edit dimension");
      }
    } catch (error) {
      console.error("Error during add/edit dimension:", error);
    }
  };


  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status
    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update the row data state locally
    try {
      let response = await getAdminDimensionBlock(row.id, newStatus);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else if (response?.data?.responseCode === 400) {
        toastEmitter("danger", response?.data?.message);
        // Revert the status change if the API returns an error
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
      } else {
        console.error("Failed to change model status");
        // Revert the status change if an unexpected response is received
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
      }
    } catch (error) {
      console.error("Error during status change:", error);
      // Revert the status change in case of an error
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
    }
  };

  const deleteButtonClick = (id,name) => {
    setDeleteDimensionIdId(id)
    setDeleteDimensionName(name)
    DeleteDimensionRef.current.click();
  }

  const handleDimensionDelete = async () => {
    try {
      const response = await deleteDimensionById(deleteDimensionId);
      if (response?.data?.responseCode === 200) {
        toastEmitter('success', response.data.message)
        getListOfDimension();
      } else {
        toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
      }
    } catch (err) {
      // toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
    }
  }

  const tblColumns = [
    ...(permissionAccess?.updateAction === 1
      ? [
        {
          code: "Action",
          name: "Action",
          width: "130px",
          sortable: false,
          cell: (row) => (
            <div>
              <button
                className="border-0 bg-white"
                onClick={() => editButtonClick(row)}
              >
                <img src={EDIT_ICON} alt="Edit" className="editicon" />
              </button>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => viewButtonClick(row)}
                >  <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => deleteButtonClick(row?.id,row?.dimensionName)}
                >  <img src={DELETE_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
            </div>
          ),
        },
      ]
      : []),
    {
      code: "dimensionId",
      name: "Dimension Id",
      width: "130px",
      sortable: true,
      selector: (row) => `${row?.dimensionId}`,
    },
    {
      code: "dimensionName",
      name: "Dimension Name",
      width: "180px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.dimensionName}</div>
      ),
    },
    {
      code: "sortName",
      name: "Short Name",
      width: "150px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.sortName}</div>
      ),
    },
    {
      code: "modelName",
      name: "Model Name",
      width: "180px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.modelResponse.modelName}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      sortable: true,
      cell: (row) => (
        <div class="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },
    {
      code: "updatedDate",
      name: "Last Update",
      sortable: true,
      selector: (row) => moment(row?.updatedDate).format("MM/DD/YYYY"), // Adjust format as needed
    },
  ];

  const handleClearFilter = () => {
    localStorage.removeItem("DimesionMenegmentModalId")
    setModelId("")
  }

  return (
    <>
      {permissionAccess?.addAction == 0 &&
        permissionAccess?.updateAction == 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading
              firstData="Assessment Modeling"
              icon={RIGHTARROW_ICON}
              secondData="Dimension Management"
            />
            <div className="container-fluid">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  searchValue={searchValue}
                  onSearchChange={handleSearchChange}
                  data="Dimension"
                  addButtonClick={addButtonClick}
                  addbuttonClick={addbuttonClick}
                  permissionAccessbtn={permissionAccess?.addAction}
                  labelName="Select Model"
                  lableclassName="addInput-label"
                  name="companyId"
                  options={modelList}
                  className="form-control addInputText-lable"
                  handleSelect={handlemodalSelect}
                  value={dimesionModalId ? dimesionModalId : modelId}
                  showDropdown={true}
                  clearbtn={true}
                  handleClear={handleClearFilter}
                />
                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={{}}
                  _totalRows={totalElement}
                  pending={pending}
                  setPending={setPending}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
              </div>
            </div>
          </div>

          <Modal
            heading="Dimension Management"
            modalClick={addbuttonClick}
            title={isEditMode ? "Edit Dimension" : isViewMode ? "View Dimension" : "Add Dimension"}
            onAddItem={onAddOrEditModel}
            buttonLable={isViewMode ? "" : isEditMode ? "Update" : "Add"}
            className="modal-lg"
          >
            <div className="row">
              <div className="col-md-4">
                <Inputwithlable
                  placeHolder="Enter Dimension Name"
                  name="dimensionName"
                  type="text"
                  showastrict={true}
                  labelName="Enter Dimension Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={dimensionPayload?.dimensionName} // Bind selected value
                  handleChange={handleChange} // Unified onChange handler
                  disable={isViewMode}
                />
              </div>
              <div className="col-md-4">
                <Inputwithlable
                  placeHolder="Enter Dimension Short Name"
                  name="sortName"
                  type="text"
                  labelName="Enter Dimension Short Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={dimensionPayload?.sortName}
                  handleChange={handleChange}
                  disable={isViewMode}
                />
              </div>
              <div className="col-md-4">
                <DropDownWithLabel
                  labelName="Select Model"
                  lableclassName="input-label"
                  name="modelId"
                  showastrict={true}
                  className="form-control inputText-lable"
                  options={modelListActive}
                  value={dimensionPayload.modelId}
                  handleSelect={handleSelect}
                  disabled={isViewMode || dimensionPayload?.enable === false}
                  message={dimensionPayload?.enable === false ? "This dimension already exists ,and the model cannot be modified" : ""}
                />
              </div>

              <div className="col-md-12">
                <Textareawithlable
                  placeHolder="Enter Dimension Description"
                  name="dimensionDescription"
                  type="text"
                  labelName="Enter Dimension Description"
                  lableclassName="input-label"
                  className="textarea inputText-lable"
                  showastrict={true}
                  value={dimensionPayload?.dimensionDescription}
                  handleChange={handleChange}
                  disabled={isViewMode}
                />
              </div>
            </div>
          </Modal>

          <SuccessModel
            title={isEditMode ? "Dimension Updated" : "Dimenstion Added"}
            SuccessModel={successModalRef}
          />
          <DeleteModal
            DeleteModalRef={DeleteDimensionRef}
            title="Dimension"
             name={deleteDimensionName}
            warningMsg="⚠️If you delete this Dimensions. All the Sub-dimensions and criteria associated with it will automatically deleted."
            handleDelete={handleDimensionDelete}
          />
        </>
      )}
    </>
  );
};

export default DimensionsManagement;
